import React from "react";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import { auth } from "./firebase";
import InputComponent from "./input";

const UserData = props => {
  const { user, providerId } = props;

  return (
    <div>
      <h5>Authentication provided by {providerId}</h5>
      <InputComponent
        name="email"
        type="email"
        label="Email"
        isInvalid={!user.emailVerified}
        message={!user.emailVerified ? "The email has not been verified" : ""}
        disabled
        value={user.email || ""}
        onChange={() => toast.error("Can't change email")}
      />
      <InputComponent
        name="displayName"
        type="email"
        label="Display Name"
        disabled
        value={user.displayName || ""}
        onChange={() => toast.error("Can't change email")}
      />
      {providerId === "password" && (
        <Button
          color="primary"
          onClick={() =>
            auth
              .sendPasswordResetEmail(user.email)
              .then(() => toast.success("Password reset Email Sent"))
              .catch(() => toast.error("Email sending failed"))
          }
        >
          Send Reset Password Email
        </Button>
      )}
    </div>
  );
};

export default UserData;
